/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/
import {WealthyEnv} from "helpers";

const publicBlogCta = [
  {
    category: "wealth",
    tagline: "Review your Portfolio",
    description: "Get your Portfolio Reviewed by a Trained Wealth Manager",
    url: "https://calendly.com/team-wealthy/lets-meet?utm_source=blog&utm_medium=ClientBlog&utm_campaign=Client-Blog-CTA&month=2023-06",
    urlText: "Get Started",
    isClient: true
  },
  {
    category: "tax",
    tagline: "Save on your Tax",
    description: "Save on taxes by investing wisely",
    url: "https://calendly.com/team-wealthy/lets-meet?utm_source=blog&utm_medium=ClientBlog&utm_campaign=Client-Blog-CTA&month=2023-06",
    urlText: "Get Started",
    isClient: true
  },
  {
    category: "loan",
    tagline: "Create your financial plan",
    description: "Want to create your financial plan?",
    url: "https://calendly.com/team-wealthy/lets-meet?utm_source=blog&utm_medium=ClientBlog&utm_campaign=Client-Blog-CTA&month=2023-06",
    urlText: "Get Started",
    isClient: true
  },
  {
    category: "investment",
    tagline: "Investment Planning",
    description: "Need help with investment planning?",
    url: "https://calendly.com/team-wealthy/lets-meet?utm_source=blog&utm_medium=ClientBlog&utm_campaign=Client-Blog-CTA&month=2023-06",
    urlText: "Get Started",
    isClient: true
  },
  {
    category: "markets",
    tagline: "Review your Portfolio",
    description: "Get your Portfolio Reviewed by a Trained Wealth Manager",
    url: "https://calendly.com/team-wealthy/lets-meet?utm_source=blog&utm_medium=ClientBlog&utm_campaign=Client-Blog-CTA&month=2023-06",
    urlText: "Get Started",
    isClient: true
  },
  {
    category: "insurance",
    tagline: "Your Insurance Plan",
    description: "Do you have adequate insurance cover?",
    url: "https://calendly.com/team-wealthy/lets-meet?utm_source=blog&utm_medium=ClientBlog&utm_campaign=Client-Blog-CTA&month=2023-06",
    urlText: "Get Started",
    isClient: true
  },
  {
    category: "nri",
    tagline: "Investments Oppurtunities in India",
    description: "Utilise your funds by investing in multiple products through Wealthy.",
    url: `${WealthyEnv.URL}/nri-investment-options-india#book-appointment`,
    urlText: "Book an Appointment",
    isClient: true
  },
  {
    category: "partner-blog",
    tagline: "Become a Wealthy Partner",
    description: "Join us and upscale your business to a whole new level",
    url: `?utm_campaign=Banner-Partner-page&utm_source=Partnerblog#register`,
    urlText: "Join as Partner",
    isClient: false
  },
  {
    category: "partner-news",
    tagline: "Become our Wealth Partner",
    description: "Join us and upscale your business to a whole new level",
    url: `?utm_campaign=Banner-Partner-page&utm_source=partnernews#register`,
    urlText: "Join as partner",
    isClient: false
  }
];

export default publicBlogCta;
